// @vendors
const Immutable = require('immutable');

function setInitialState() {
    return Immutable.fromJS({
        isFetching: false,
        fetchSuccess: true,
        errorReceived: false
    });
}

function brokerMyInvestmentsReducer(state = setInitialState(), action) {
    switch (action.type) {
        default:
            return state;
    }
}

module.exports = brokerMyInvestmentsReducer;
